module.exports = __webpack_public_path__ + "img/jiancezixun.601d00bd.svg";